import { FormActionsMui } from '@app/components/form/FormActionsMui';
import { Page } from '@app/components/page/Page';
import { StationIcon } from '@app/components/stations/StationIcon';
import { useAppData } from '@app/core/app-data';
import { useToast } from '@app/core/notifications';
import { canEditStation } from '@app/core/stations/helpers';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useStationUpdateMutation } from '@app/core/stations/hooks/useStationUpdateMutation';
import { yupResolver } from '@hookform/resolvers/yup';
import { capitalizeFirst, getLanguage, useRouter } from '@mi-front/core';
import { LanguageField } from '@mi-front/ui';
import { Box, Grid, Stack } from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import * as yup from 'yup';
import { AdminStationsBreadcrumbs } from '../header';

const stationEditSchema = yup.object().shape({
  language: yup.string().required(),
});

export function AdminStationsEditPage() {
  const station = useActiveStation();
  const canEdit = canEditStation(station);
  const { $t } = useIntl();
  const { notifySuccess } = useToast();
  const { refetchStations } = useAppData();

  const title = $t({
    id: 'admin.stations.editScreen.title',
    defaultMessage: 'Editar emisora',
  });

  const { history } = useRouter();
  const updateMutation = useStationUpdateMutation();

  if (!canEdit) {
    return <Redirect to={`/admin/stations/${station.slug}`} />;
  }

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<StationIcon />}
        title={
          <>
            {station.name}
            <Box component="span" sx={{ opacity: 0.7 }}>
              {' '}
              — {title}
            </Box>
          </>
        }
        breadcrumbs={
          <AdminStationsBreadcrumbs
            active={station}
            title={$t({
              id: 'common.actions.edit',
              defaultMessage: 'Editar',
            })}
          />
        }
      />
      <Page.Content>
        <FormContainer
          values={{
            language: getLanguage(station.language)?.id,
          }}
          resolver={yupResolver(stationEditSchema)}
          onSuccess={async (data) => {
            await updateMutation.mutateAsync({
              idOrSlug: station.id,
              data,
            });

            refetchStations();
            history.push(`/admin/stations/${station.slug}`);
            notifySuccess(
              capitalizeFirst(
                $t({
                  id: 'common.notifications.updated',
                  defaultMessage: '{entity} actualizado',
                }),
              ),
            );
          }}
        >
          <Stack>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <LanguageField name="language" required />
              </Grid>
            </Grid>
            <FormActionsMui
              cancel={`/admin/stations/${station.slug}`}
              saveLabel={$t({
                id: 'common.actions.save',
                defaultMessage: 'Guardar',
              })}
            />
          </Stack>
        </FormContainer>
      </Page.Content>
    </Page>
  );
}
